/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Hero del modal — misma jerarquía que la hoja de Inicio día 1 (kicker · nombre · meta).
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors } from '../../../shared/theme/ticketColors';
import type { BranchAccess } from '../../../shell/session/store/sessionTypes';
import { BranchCashStatusPill } from './BranchCashStatusPill';
import { formatBranchCount, formatBranchLocation } from './branchSelectionUi';

type Props = {
  mode: 'pick' | 'switch';
  branch?: BranchAccess;
  cashOpen: boolean | null;
  branchCount: number;
};

export function BranchSelectionHero({
  mode,
  branch,
  cashOpen,
  branchCount,
}: Props) {
  if (mode === 'switch' && branch) {
    const location = formatBranchLocation(branch.location);

    return (
      <View style={localStyles.heroBlock} testID="auth.branch-selector.hero">
        <Text style={localStyles.kicker}>Estás acá</Text>

        <View style={localStyles.titleRow}>
          <Text style={localStyles.title} numberOfLines={2}>
            {branch.name}
          </Text>
          {cashOpen !== null ? <BranchCashStatusPill cashOpen={cashOpen} /> : null}
        </View>

        {location ? (
          <Text style={localStyles.lead} numberOfLines={2}>
            {location}
          </Text>
        ) : null}
      </View>
    );
  }

  const lead =
    branchCount > 0
      ? `${formatBranchCount(branchCount)} disponibles`
      : 'Creá tu primera sucursal para empezar a operar.';

  return (
    <View>
      <Text style={localStyles.lead}>{lead}</Text>
    </View>
  );
}

const localStyles = StyleSheet.create({
  heroBlock: {
    paddingBottom: spacing.sm,
    gap: 4,
  },
  kicker: {
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.ink2,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
    marginTop: 2,
  },
  title: {
    flex: 1,
    minWidth: 0,
    fontSize: 22,
    fontWeight: '800',
    color: ticketColors.ink,
    letterSpacing: -0.3,
  },
  lead: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink2,
    lineHeight: 18,
    marginTop: 2,
  },
});
